import { createAsyncThunk } from "@reduxjs/toolkit";
import { iStateMessage } from "@/customTypes/GenericReduxTypes";
import { iGenericResponse } from "@/customTypes/CommonServiceTypes";
import { curryGetThunkName } from "@/projectUtils/ReduxUtil";
import { httpStatusCodes } from "@/customTypes/NetworkTypes";
import { paymentGatewayService } from "@/services/api/cresivoxServer";
import { iPaymentGatewayDTO, REDUCER_NAME } from "./Types";

const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);

// Add Payment Gateway
export const addPaymentGateway = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { data: iPaymentGatewayDTO },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("addPaymentGateway"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({ data }, { rejectWithValue }) => {
    try {
       
      const response = await paymentGatewayService.createPaymentGateway(data);
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                  paymentGateway: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({ httpStatusCode, message });
            }
          }
          default: {
            return rejectWithValue({ httpStatusCode, message });
          }
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

// Get Payment Gateway List
export const getPaymentGatewayList = createAsyncThunk<
  iGenericResponse<any | null> | null,
  void,
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("getPaymentGatewayList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async (_, { rejectWithValue }) => {
    try {
      const response = await paymentGatewayService.getAllPaymentGateways();
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              return {
                data: {
                    data: data.data,
                  message,
                },
              };
            } else {
              return rejectWithValue({ httpStatusCode, message });
            }
          }
          default: {
            return rejectWithValue({ httpStatusCode, message });
          }
        }
      } else {
        return rejectWithValue({ message: "No response received" });
      }
    } catch (error) {
      return rejectWithValue({ message: "Something went wrong" });
    }
  }
);

